export enum PartRequestStatus {
  Draft = 1,
  Pending = 2,
  Approved = 3,
  Rejected = 4,
  Issued = 5
}